/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import VueCompositionAPI from '@vue/composition-api';
import _Rate from './rate.js';
import { withInstall } from '../utils/withInstall.js';
import './style/css.js';
import './type.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/slicedToArray';
import '@babel/runtime/helpers/defineProperty';
import 'tdesign-icons-vue';
import '../hooks/useVModel.js';
import 'lodash/kebabCase';
import './props.js';
import '../hooks/useConfig.js';
import '../config-provider/useConfig.js';
import '../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';
import '../tooltip/index.js';
import '../tooltip/tooltip.js';
import '../_chunks/dep-1461d230.js';
import 'lodash/isFunction';
import '../tooltip/props.js';
import '../popup/props.js';
import '../popup/popup.js';
import '@popperjs/core';
import 'lodash/debounce';
import '../utils/dom.js';
import 'vue';
import 'raf';
import 'lodash/isString';
import '../utils/easing.js';
import '../utils/render-tnode.js';
import 'lodash/camelCase';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../_common/js/utils/set-style.js';
import '../popup/container.js';
import '../config-provider/config-receiver.js';
import '../utils/mixins.js';
import '../utils/event.js';
import '../popup/utils.js';
import '../utils/map-props.js';
import '../tooltip/type.js';
import 'lodash/capitalize';

var Rate = withInstall(_Rate, VueCompositionAPI);

export { Rate, Rate as default };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/rate/index.js
// module id = null
// module chunks = 